// extracted by mini-css-extract-plugin
module.exports = {"name":"H1_name__2v0yt","br":"H1_br__ZsnK-"};